import React, {useEffect, useState} from 'react';
import { Bar } from '@ant-design/charts';
import { Segmented, Row, Col } from 'antd';

const BrandChart = ({data, isBrandSelected}) => {
    const [graphData, setGraphData] = useState([]);
    const [segmentedValue, setSegmentedValue] = useState(1);

    useEffect(() => {
        organizeData(data);
    }, [data, isBrandSelected]);

    const organizeData = (tableData) => {
        const memo = {};

        tableData.forEach(element => {
            const field = isBrandSelected ? `${element.n} - ${element.cr}` : `${element.bn} - ${element.cr}`
            const graphLabel = isBrandSelected ? `${element.n} - ${element.cr}` : `${element.bn} - ${element.cr}`
            if(memo.hasOwnProperty(field) && memo[field].cr === element.cr) {
                memo[field].lt += element.lt;
                memo[field].a += element.a;
                return;
            }

            memo[field] = {
                bn: graphLabel,
                cr: element.cr,
                a: element.a,
                lt: element.lt
            };

        });

        const result = Object.values(memo);
        setGraphData(result)

    };

    const segmentedOptions = [
        {label: 'Adet Bazlı', value: 1},
        {label: 'Fiyat Bazlı', value: 2}
    ];

    const chartConfig = {
        data: graphData,
        xField: segmentedValue === 1 ? 'a' : 'lt',
        yField: 'bn',
        seriesField: 'bn',
        legend: {
          position: 'top-left',
        },
        style: {
            height: '700px'
        },
        tooltip: {
            formatter: (d) => {
                return { name: d.bn, value: Intl.NumberFormat().format(segmentedValue === 1 ? d.a : d.lt) };
            }
        }
    };

    return(
        <>
            <Row justify={'center'}>
                <Segmented options={segmentedOptions} valu={segmentedValue} onChange={setSegmentedValue}/>
            </Row>
            <Row justify={'center'}>
                <Col span={20}>
                    <Bar {...chartConfig}  appendPadding={8}/> 
                </Col>
            </Row>
        </>
    )
}

export default BrandChart;